/**
 * LayerPanel - Main export
 *
 * Architecture:
 * - LayerPanelContainer: Thin wrapper that bridges parent data to presenter
 * - LayerPanelPresenter: Pure UI component with local UI state only
 * - useLayerOperations: Hook with all atomic state mutation operations
 *
 * Key principles:
 * 1. Every operation is atomic (single setRamp call)
 * 2. All operations use IDs, never array indices
 * 3. Container/Presenter separation for clean architecture
 */

export { LayerPanel, LayerPanelContainer } from "./LayerPanelContainer";
export type { LayerPanelContainerProps } from "./LayerPanelContainer";

export { LayerPanelPresenter } from "./LayerPanelPresenter";
export type { LayerPanelPresenterProps } from "./LayerPanelPresenter";

export { useLayerOperations } from "./useLayerOperations";
export type { LayerOperations } from "./useLayerOperations";
